import { loadStripe } from "@stripe/stripe-js";
import { api } from "@/lib/api";

let _promise = null;

// publishable key comes from the backend so test→live switches need no frontend rebuild
export function getStripe() {
  if (!_promise) {
    _promise = api.get("/payments/config").then((r) => loadStripe(r.data.publishable_key));
  }
  return _promise;
}

export const STRIPE_APPEARANCE = {
  theme: "night",
  variables: {
    colorPrimary: "#E50914",
    colorBackground: "#17171f",
    colorText: "#f1f5f9",
    colorDanger: "#fb7185",
    borderRadius: "10px",
    fontFamily: "Manrope, system-ui, sans-serif",
  },
  rules: {
    ".Input": { border: "1px solid rgba(255,255,255,.12)" },
    ".Input:focus": { border: "1px solid #E50914", boxShadow: "0 0 0 3px rgba(229,9,20,.25)" },
    ".Tab": { border: "1px solid rgba(255,255,255,.12)" },
  },
};
